import { studio410InfluenceGraphFixture } from './fixtures';
import type { InfluenceGraphModel, InfluenceGraphProvider } from './model';
export class FixtureInfluenceGraphProvider implements InfluenceGraphProvider {
  constructor(private readonly fixture: InfluenceGraphModel | null = studio410InfluenceGraphFixture) {}
  async getInfluenceGraph(accountId: string, subjectId: string) { if (!this.fixture) return null; return this.fixture.account.id === accountId && this.fixture.subject.id === subjectId ? this.fixture : null; }
}
export const influenceGraphProvider = new FixtureInfluenceGraphProvider();
